import React, { useEffect, useState } from "react";
import BookCard from "../BookCard/BookCard";

const AllBooks = () => {
  const [booksData, setBooksData] = useState([]);

  useEffect(() => {
    fetch("https://infinite-cliffs-81680.herokuapp.com/books")
      .then((res) => res.json())
      .then((data) => setBooksData(data));
  }, []);
  return (
    <div className="row">
      {booksData.length === 0 && (
        <div className="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {booksData.map((book) => (
        <BookCard book={book}></BookCard>
      ))}
    </div>
  );
};

export default AllBooks;
